import { type ReactNode } from "react";

/**
 * A group of rows on the shift screen, on its own surface.
 *
 * The screen had five headings over five lists that all looked the same, so nothing read as
 * belonging together. This is the one shape those groups share: an optional label above, rows
 * separated by hairlines, on a surface that lifts the group off the page. Rows bring their own
 * padding — the card only owns the sides.
 */
export function DetailCard({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-1">
      {title && (
        <h2 className="text-xs font-bold uppercase tracking-wide text-txt-secondary">{title}</h2>
      )}
      <div className="flex flex-col divide-y divide-solid divide-bordercolor-primary rounded-xl bg-surface-primary px-4">
        {children}
      </div>
    </section>
  );
}
